<template>
  <v-container>
    <v-row>
      <v-col cols="1"></v-col>
      <v-col>
        <v-tabs-items v-model="signuptab">
          <v-tab-item><SignupPackage v-on:gotoNext="gotoNext()"></SignupPackage></v-tab-item>
          <v-tab-item><SignupFaxNumber v-on:gotoNext="gotoNext()"></SignupFaxNumber></v-tab-item>
          <v-tab-item><SignupInfo v-on:gotoNext="gotoNext()"></SignupInfo></v-tab-item>
          <v-tab-item><SignupUsername v-on:gotoNext="gotoNext()"></SignupUsername></v-tab-item>
          <v-tab-item><SignupSummary></SignupSummary></v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col cols=3>
        <div style="width:240px">
        <v-tabs 
          v-model="signuptab"
          :vertical="true"
          :grow="false"
          dark
        >
          <v-tab>Select package</v-tab>
          <v-tab>Fax Number</v-tab>
          <v-tab>Your Information</v-tab>
          <v-tab>Account</v-tab>
          <v-tab>Review</v-tab>
        </v-tabs>
        </div>
      </v-col>
  </v-row>
  </v-container>
</template>

<script>

  import SignupPackage from './SignupPackage.vue';
  import SignupFaxNumber from './SignupFaxNumber.vue';
  import SignupUsername from './SignupUsername.vue';
  import SignupInfo from './SignupInfo.vue';
  import SignupSummary from './SignupSummary.vue';
  import SignupMixin from '../mixins/SignupMixin.vue';

  export default {
    name: 'Signup',
    props: {
      product: { 
        required: true,
      },
    },
    mixins: [SignupMixin],
    components: {
      SignupPackage,
      SignupFaxNumber,
      SignupUsername,
      SignupInfo,
      SignupSummary,
    },
    data: () => ({
     
    }),
    methods: {
      gotoNext: function() {
        this.signuptab++;
      }
    },
    beforeMount() {
      this.$store.dispatch('updateSelectedProduct', this.product);
    },
    watch: {

    },
    filters: {

    },
  }
</script>
